import { FC } from 'react';
import { ChildrenPropType } from 'src/utils/types';

type Props = {
  tHead: ChildrenPropType;
  children: ChildrenPropType;
};

export const CheckoutConfirmationTableLayout: FC<Props> = ({ tHead, children }) => (
  <div className="card hoverable summary">
    <table className="table items">
      <thead>{tHead}</thead>
      <tbody>{children}</tbody>
    </table>
  </div>
);
